/**
* [Flags]
*/
export var AssignmentFolderRights;
(function (AssignmentFolderRights) {
    AssignmentFolderRights[AssignmentFolderRights["None"] = 0] = "None";
    AssignmentFolderRights[AssignmentFolderRights["Use"] = 1] = "Use";
    AssignmentFolderRights[AssignmentFolderRights["Open"] = 2] = "Open";
    AssignmentFolderRights[AssignmentFolderRights["View"] = 4] = "View";
    AssignmentFolderRights[AssignmentFolderRights["Edit"] = 8] = "Edit";
    AssignmentFolderRights[AssignmentFolderRights["Add"] = 16] = "Add";
    AssignmentFolderRights[AssignmentFolderRights["Delete"] = 32] = "Delete";
    AssignmentFolderRights[AssignmentFolderRights["Administrate"] = 64] = "Administrate";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission1"] = 128] = "CustomPermission1";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission2"] = 256] = "CustomPermission2";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission3"] = 512] = "CustomPermission3";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission4"] = 1024] = "CustomPermission4";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission5"] = 2048] = "CustomPermission5";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission6"] = 4096] = "CustomPermission6";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission7"] = 8192] = "CustomPermission7";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission8"] = 16384] = "CustomPermission8";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission9"] = 32768] = "CustomPermission9";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission10"] = 65536] = "CustomPermission10";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission11"] = 131072] = "CustomPermission11";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission12"] = 262144] = "CustomPermission12";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission13"] = 524288] = "CustomPermission13";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission14"] = 1048576] = "CustomPermission14";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission15"] = 2097152] = "CustomPermission15";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission16"] = 4194304] = "CustomPermission16";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission17"] = 8388608] = "CustomPermission17";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission18"] = 16777216] = "CustomPermission18";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission19"] = 33554432] = "CustomPermission19";
    AssignmentFolderRights[AssignmentFolderRights["CustomPermission20"] = 67108864] = "CustomPermission20";
    AssignmentFolderRights[AssignmentFolderRights["All"] = 134217727] = "All";
})(AssignmentFolderRights || (AssignmentFolderRights = {}));
;
